'use strict';
import { PlatformLocation } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '@environments/environment';
import { versions } from '@environments/versions';
import { WatchStorageService } from '@parts-catalog/services/watchstorage.service';
import { from } from 'rxjs';
import { take, map } from 'rxjs/operators';
export const appURL = window.location.origin;
export const domain = environment.apiUrl;
export const env = environment.production;
export const { cfAccessClientSecret } = environment;
export const s3URL = 'https://s3.ap-south-1.amazonaws.com/autotash/customers/';
export const cfAccessClientId = '9837a2eafe3ebc214f7e6dafae642cbb.access';

// api.speero.dev sits behind Cloudflare Access. Non-production builds must send the
// service-token headers on every call to the API or Access answers with a login
// redirect, which the browser surfaces as a CORS error.
export function appendCfAccessHeaders(headers: HttpHeaders): HttpHeaders {
  if (env) {
    return headers;
  }
  return headers
    .append('CF-Access-Client-Id', cfAccessClientId)
    .append('CF-Access-Client-Secret', cfAccessClientSecret);
}

// Options object for calls that send no other headers (public API endpoints).
export function cfAccessOptions() {
  return { headers: appendCfAccessHeaders(new HttpHeaders()) };
}
declare let imprint: any;

@Injectable()
export class GetTokenNow {
  browserTests: any = [
    'audio',
    'availableScreenResolution',
    'canvas',
    'colorDepth',
    'cookies',
    'cpuClass',
    'deviceDpi',
    'doNotTrack',
    'indexedDb',
    'language',
    'localStorage',
    'pixelRatio',
    'platform',
    'plugins',
    'processorCores',
    'screenResolution',
    'sessionStorage',
    'timezoneOffset',
    'touchSupport',
    'userAgent',
    'webGl'
  ];
  imprintValue: any;
  subscribtion: any;
  constructor(private httpClient: HttpClient, private watchStorage: WatchStorageService, platformLocation: PlatformLocation) {
    const subscription = from(imprint.test(this.browserTests));
    subscription.subscribe(
      fingerprint => {
        this.imprintValue = fingerprint;
        localStorage.setItem('imprintValue', this.imprintValue);
      },
      error => {
        console.log(error);
      }
    );
  }
  get() {
    return localStorage.getItem('accessToken');
  }
  askForNewToken(body) {
    return this.httpClient.put(`${domain}/refreshToken`, body).pipe(map(res => res as any));
  }
  checkToken() {
    const token = localStorage.getItem('accessToken');
    const jwtHelper = new JwtHelperService();
    if (token && jwtHelper.isTokenExpired(token)) {
      const body = {
        deviceId: localStorage.getItem('imprintValue'),
        refreshToken: localStorage.getItem('refreshToken')
      };
      this.askForNewToken(body)
        .pipe(take(1))
        .subscribe((response: any) => {
          if (response.case === 1) {
            this.watchStorage.setItem('accessToken', response.accessToken);
            this.watchStorage.setItem('refreshToken', response.refreshToken);
            return response.accessToken;
          }
          return localStorage.getItem('accessToken');
        });
    }
    return localStorage.getItem('accessToken');
  }
  getHeaders() {
    let headersNow: HttpHeaders = new HttpHeaders();
    headersNow = headersNow.append('Content-Type', 'application/json');
    headersNow = headersNow.append('Authorization', `Bearer ${this.checkToken()}`);
    headersNow = headersNow.append('App-version', `Angular-Web-SPA ${versions.version}`);
    if (!env) {
      headersNow = headersNow.append('CF-Access-Client-Id', '9837a2eafe3ebc214f7e6dafae642cbb.access');
      headersNow = headersNow.append('CF-Access-Client-Secret', cfAccessClientSecret);
    }
    return { headers: headersNow };
  }
  options() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', `Bearer ${this.checkToken()}`);
    headers = headers.append('App-version', `Angular-Web-SPA ${versions.version}`);
    if (!env) {
      headers = headers.append('CF-Access-Client-Id', '9837a2eafe3ebc214f7e6dafae642cbb.access');
      headers = headers.append('CF-Access-Client-Secret', cfAccessClientSecret);
    }
    return { headers };
  }
  optionsTeam() {
    let headersTeam: HttpHeaders = new HttpHeaders();
    headersTeam = headersTeam.append('Content-Type', 'application/json');
    headersTeam = headersTeam.append('Authorization', `Bearer ${this.checkToken()}`);
    headersTeam = headersTeam.append('App-version', `Angular-Web-SPA ${versions.version}`);
    if (!env) {
      headersTeam = headersTeam.append('CF-Access-Client-Id', '9837a2eafe3ebc214f7e6dafae642cbb.access');
      headersTeam = headersTeam.append('CF-Access-Client-Secret', cfAccessClientSecret);
    }
    return { headers: headersTeam };
  }
  optionsProvider() {
    let headersProvider: HttpHeaders = new HttpHeaders();
    headersProvider = headersProvider.append('Content-Type', 'application/json');
    headersProvider = headersProvider.append('Authorization', `Bearer ${this.checkToken()}`);
    headersProvider = headersProvider.append('App-version', `Angular-Web-SPA ${versions.version}`);
    if (!env) {
      headersProvider = headersProvider.append('CF-Access-Client-Id', '9837a2eafe3ebc214f7e6dafae642cbb.access');
      headersProvider = headersProvider.append('CF-Access-Client-Secret', cfAccessClientSecret);
    }
    return { headers: headersProvider };
  }

  getParams(query) {
    let params: HttpParams = new HttpParams();
    for (const key of Object.keys(query)) {
      if (query[key]) {
        if (query[key] instanceof Array) {
          query[key].forEach(item => {
            params = params.append(`${key.toString()}[]`, item);
          });
        } else {
          params = params.append(key.toString(), query[key]);
        }
      }
    }
    return params;
  }
}

/**
 *
 *
 * Simple object check.
 *
 *
 *
 * @param item
 * @returns
 */
export function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
}

/**
 * Deep merge two objects.
 *
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
  if (!sources.length) {
    return target;
  }
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, { [key]: {} });
        }
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}

export function tab(body) {
  return body;
}

export function databaseExists(nameDB, callback) {
  let dbExists = true;
  const request = window.indexedDB.open(nameDB);
  request.onupgradeneeded = (e) => {
    if (request.result.version === 1) {
      dbExists = false;
      window.indexedDB.deleteDatabase(nameDB);
      if (callback) {
        callback(dbExists);
      }
    }
  };
  request.onsuccess = (e) => {
    if (dbExists) {
      if (callback) {
        callback(dbExists);
      }
    }
  };
}

export const warrantiesList: any = ['3 أيام', '7 أيام', '15 يوم', '20 يوم', 'شهر'];

export function generateYear(from?: number, to?: number) {
  const years = [];

  const nextYear = new Date().getFullYear() + 1;
  for (let i = to || nextYear; i > (from || 1990); i--) {
    years.push(i);
  }
  return years;
}

export function validateId(id: string): boolean {
  const pattern = /^[0-9a-fA-F]{24}$/i;
  return pattern.test(id);
}

export function handleReadableMessage(res) {
  if (res?.readableMessageType) {
    this.toastr[res.readableMessageType](res.readableMessage);
  }
}


export const banksList: any = [
  { id: 'مصرف الإنمـاء', label: 'مصرف الإنمـاء' },
  { id: 'مصرف الراجحي', label: 'مصرف الراجحي' },
  { id: 'مجموعة سامبا المالية', label: 'مجموعة سامبا المالية' },
  { id: 'بنك ساب', label: 'بنك ساب' },
  { id: 'بنك الرياض', label: 'بنك الرياض' },
  { id: 'بنك الجزيرة', label: 'بنك الجزيرة' },
  { id: 'بنك البلاد', label: 'بنك البلاد' },
  { id: 'البنك العربي', label: 'البنك العربي' },
  { id: 'البنك السعودي', label: 'البنك السعودي' },
  { id: 'البنك السعودي   الهولندي', label: 'البنك السعودي   الهولندي' },
  { id: 'البنك السعودي', label: 'البنك السعودي' },
  { id: 'البنك الأهلي  التجاري', label: 'البنك الأهلي  التجاري' }
];